import httpClient from '@/shared/http-eserv-client';

const getPermitById = (ePermitId) => httpClient
  .get(`/ePermits/${ePermitId}/?$expand=applicantCompany,ApplicantContact,ContractorCompany,ContractorContact,EngineerCompany,EngineerContact,InstallerCompany,InstallerContact,ePermitSite($expand=eSiteTanks,OwnerCompany,OwnerContact,siteAddress)`);
const postPermit = (data) => httpClient.post('/ePermits', data);
const getPermitByStatus = (status) => httpClient.get(`/ePermits/?$filter=status eq '${status}'`);
const getApplicationWorkLists = () => httpClient.get('/ApplicationWorkLists/newList');
const getApplicationWorkListById = (permitId) => httpClient.get(`/ApplicationWorkLists/${permitId}`);
const updateApplicationWorkLists = (data) => httpClient.patch('/ApplicationWorkLists', data);
const fetchFeeDetails = (ePermitId) => httpClient.get(`/ApplicationRequests/ePermitApplication?ePermitId=${ePermitId}&$expand=applicationFeeDetails($orderby=sortOrderId)`);
const submitApplication = (data) => httpClient.post('/ePermits/Submit', data);
const documentUploadDetails = () => httpClient.get('/DocumentTypes/permit');

const uploadFile = (document) => httpClient.post('/ApplicationXDocuments', document);
const getUploadedDocuments = (ePermitId) => httpClient.get(`/ePermits/ePermitDocuments/?epermitid=${ePermitId}&$expand=appdocument`);
const deleteDocument = (documentId) => httpClient.delete(`/ApplicationXDocuments/${documentId}`);

// dropdowns for tank info screen
const getULCAPI = () => httpClient.get('/StaticMessages/ULC_API');
const getFacilityType = () => httpClient.get('/StaticMessages/FacilityType');
const getTankType = () => httpClient.get('/StaticMessages/TankType');
const getProductType = () => httpClient.get('/StaticMessages/ProductType');
const getForASTsOnly = () => httpClient.get('/StaticMessages/ForASTsOnly');
const getASTSingleWall = () => httpClient.get('/StaticMessages/ASTSingleWall');
const getASTDoubleWall = () => httpClient.get('/StaticMessages/ASTDoubleWall');
const getTankLeakDetection = () => httpClient.get('/StaticMessages/TankLeakDetection');
const getOverfillProtection = () => httpClient.get('/StaticMessages/OverfillProtection');
const getSump = () => httpClient.get('/StaticMessages/Sump');
const getSpillContainmentSystem = () => httpClient.get('/StaticMessages/SpillContainmentSystem');
const getPipingLeakDetection = () => httpClient.get('/StaticMessages/PipingLeakDetection');
const getPipingMaterial = () => httpClient.get('/StaticMessages/PipingMaterial');
const getReasonForRemoval = () => httpClient.get('/StaticMessages/ReasonForRemoval');

export {
  getPermitById,
  postPermit,
  getPermitByStatus,
  getFacilityType,
  getTankType,
  getApplicationWorkLists,
  getApplicationWorkListById,
  updateApplicationWorkLists,
  getULCAPI,
  getProductType,
  getForASTsOnly,
  getASTSingleWall,
  getASTDoubleWall,
  getTankLeakDetection,
  getOverfillProtection,
  getSump,
  getPipingLeakDetection,
  getPipingMaterial,
  getSpillContainmentSystem,
  fetchFeeDetails,
  submitApplication,
  getUploadedDocuments,
  deleteDocument,
  documentUploadDetails,
  uploadFile,
  getReasonForRemoval,
};
